import React from "react";
import UserAvatar from "../../../components/UserAvatar";
import { formatIDR } from "../../../utils/helpers/formatIDR";

const TopCashiers = ({ cashiers = [], loading = false }) => (
  <aside
    className="card dashboard-card dashboard-top-products-card dashboard-top-cashiers-card h-100"
    aria-labelledby="top-cashiers-title">
    <div className="card-header">
      <h3 className="card-title mb-0" id="top-cashiers-title">
        Penjualan Terbanyak
      </h3>
      <button
        type="button"
        className="badge bg-primary-lt text-primary border-0"
        data-bs-toggle="modal"
        data-bs-target="#modal-sale-cashier-summary"
        aria-label="Lihat rekap penjualan per kasir"
        disabled={loading}>
        Top 5 Kasir ↗
      </button>
    </div>
    <div className="card-body dashboard-product-feed">
      {loading ? (
        [...Array(5)].map((_, index) => <div className="dashboard-product-skeleton placeholder" key={index} />)
      ) : cashiers.length ? (
        <ol className="list-unstyled m-0">
          {cashiers.slice(0, 5).map((cashier, index) => (
            <li key={cashier.id}>
              <button
                type="button"
                className="dashboard-product-row dashboard-cashier-row"
                data-bs-toggle="modal"
                data-bs-target="#modal-sale-cashier-summary"
                aria-label={`Buka rekap penjualan per kasir dari ${cashier.name}`}>
                <span className="dashboard-product-rank" aria-hidden="true">
                  {index + 1}
                </span>
                <UserAvatar fullName={cashier.name} imageUrl={cashier.image} size="sm" justPhotoView />
                <span
                  className="dashboard-product-info"
                  title={cashier.username ? `${cashier.name} (@${cashier.username})` : cashier.name}>
                  <strong>{cashier.name}</strong>
                  <small>{Number(cashier.transaction_count || 0).toLocaleString("id-ID")} transaksi</small>
                  <small>{Number(cashier.product_count || 0).toLocaleString("id-ID")} pcs terjual</small>
                </span>
                <span className="dashboard-product-value">
                  <strong>{formatIDR(cashier.total_sales)}</strong>
                  <small>Total Penjualan</small>
                </span>
              </button>
            </li>
          ))}
        </ol>
      ) : (
        <div className="dashboard-product-empty">
          <span aria-hidden="true">◇</span>
          <p>Belum ada penjualan kasir pada periode ini.</p>
        </div>
      )}
    </div>
  </aside>
);

export default TopCashiers;
